/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Position_Toast_DeletedInputs */

const vi_warehouse_position_toast_deleted = /** @type {(inputs: Warehouse_Position_Toast_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã ngừng dùng vị trí`)
};

/**

* @param {Warehouse_Position_Toast_DeletedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_position_toast_deleted = /** @type {((inputs?: Warehouse_Position_Toast_DeletedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Position_Toast_DeletedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_position_toast_deleted(inputs)
});